module.exports = __webpack_public_path__ + "img/636@2x.75e71838.png";